import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flush", "children"];
import styled from 'foundations-theming/utils';
import { usePopoverContext } from './PopoverContext';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { usePopoverHelpLinkContext } from '../HelpLink/HelpLinkProvider';
import { deepMerge } from '../../utils/deepMerge';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledPopoverBody = styled.div.withConfig({
  displayName: "PopoverBody__StyledPopoverBody",
  componentId: "sc-17bppzh-0"
})(({
  $use,
  $flush,
  $cssStyles,
  theme,
  $styleOverrides
}) => {
  return deepMerge(Object.assign({
    background: 'inherit',
    paddingBlockStart: $flush ? theme.space['0'] : $use === 'longform' ? theme.space['0'] : $use === 'shepherd' ? theme.space['400'] : $use === 'tooltip' || $use === 'tooltip-danger' ? theme.space['250'] : theme.space['500'],
    paddingInlineEnd: $flush ? theme.space['0'] : $use === 'longform' ? theme.space['500'] : $use === 'shepherd' ? theme.space['600'] : $use === 'tooltip' || $use === 'tooltip-danger' ? theme.space['400'] : theme.space['600'],
    paddingBlockEnd: $flush ? theme.space['0'] : $use === 'longform' ? theme.space['25'] : $use === 'shepherd' ? theme.space['400'] : $use === 'tooltip' || $use === 'tooltip-danger' ? theme.space['250'] : theme.space['0'],
    paddingInlineStart: $flush ? theme.space['0'] : $use === 'longform' ? theme.space['500'] : $use === 'shepherd' ? theme.space['600'] : $use === 'tooltip' || $use === 'tooltip-danger' ? theme.space['400'] : theme.space['600']
  }, $use === 'shepherd' ? {
    borderEndStartRadius: 'inherit',
    borderEndEndRadius: 'inherit'
  } : undefined, $use === 'tooltip' || $use === 'tooltip-danger' ? {
    borderStartStartRadius: 'inherit',
    borderStartEndRadius: 'inherit',
    borderEndEndRadius: 'inherit',
    borderEndStartRadius: 'inherit',
    lineHeight: '1.5' // TODO: Needs token
  } : undefined), $styleOverrides, $cssStyles);
});
export const PopoverBody = _ref => {
  var _helpLinkContext$popo;
  let {
      flush = false,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const helpLinkContext = usePopoverHelpLinkContext();
  const use = usePopoverContext().use;
  return /*#__PURE__*/_jsx(StyledPopoverBody, Object.assign({}, domProps, {
    $use: use,
    $flush: flush,
    $cssStyles: cssStyles,
    $styleOverrides: (_helpLinkContext$popo = helpLinkContext === null || helpLinkContext === void 0 ? void 0 : helpLinkContext.popoverStylesOverrides) !== null && _helpLinkContext$popo !== void 0 ? _helpLinkContext$popo : {},
    children: children
  }));
};